// extracted by mini-css-extract-plugin
module.exports = {"headerItem":"OfferCardHeaderItem__headerItem","headerItemTitle":"OfferCardHeaderItem__headerItemTitle"};